import lodash from "lodash";
import { extract } from "../RicosContentAPI/extract.js";
import { modify } from "../RicosContentAPI/modify.js";
import { compare } from "./utils/index.js";
class Select {
  constructor(content, onSet) {
    this.extractor = extract(content.nodes ?? []);
    this.modifier = modify(content);
    this.content = content;
    this.onSet = onSet;
    this._limit = -1;
  }
  filter(predicate) {
    this.extractor = this.extractor.filter(predicate);
    this.modifier = this.modifier.filter(predicate);
    return this;
  }
  /**
   * executes query selection
   * @returns query result
   */
  get() {
    const results = this.extractor.get();
    if (this._limit >= 0) {
      return results.slice(0, this._limit);
    }
    return results;
  }
  eq(path, value) {
    return this.filter((node) => lodash.get(node, path) === value);
  }
  gt(path, value) {
    return this.filter((node) => compare(value, lodash.get(node, path)) > 0);
  }
  lt(path, value) {
    return this.filter((node) => compare(value, lodash.get(node, path)) < 0);
  }
  isEmpty(path) {
    return this.filter((node) => lodash.get(node, path) === void 0);
  }
  isNotEmpty(path) {
    return this.filter((node) => lodash.get(node, path) !== void 0);
  }
  startsWith(path, value) {
    return this.filter((node) => lodash.get(node, path)?.startsWith?.(value));
  }
  endsWith(path, value) {
    return this.filter((node) => lodash.get(node, path)?.endsWith?.(value));
  }
  contains(path, value) {
    return this.filter((node) => lodash.get(node, path)?.includes?.(value));
  }
  limit(count) {
    this._limit = count;
    return this;
  }
  count() {
    return this.get().length;
  }
  find() {
    return this.get();
  }
  modify(setter) {
    const root = this.modifier.set(setter);
    const modifiedContent = { ...this.content, nodes: root.nodes };
    this.onSet?.(modifiedContent);
    return modifiedContent;
  }
}
const select = (content, onSet) => new Select(content, onSet);
export {
  select
};
//# sourceMappingURL=select.js.map
